<template>
    <div class="mb-3" v-if="$store.state.massShipments.length > 0">
        <div v-for="(shipment, index) in reCheckedMassShipments" :key="index" 
            class="table-tr shipment-details-block" :class="{ 'openBlock': shipment.show }">                                     
            <div class="table-tr-content shipment-details-header mass-shipments-table" :class="`block_${index}`">
                <div class="table-td" style="width:20%;justify-content: flex-start;max-width: 150px;">
                    {{ shipment.Address1 }}
                </div>                                          
                <div class="table-td" style="width:10%;justify-content: flex-start;max-width: 150px;">
                    {{ shipment.City }}
                </div>                                          
                <div class="table-td" style="width:10%;justify-content: flex-start;max-width: 150px;">
                    {{ shipment.PostCode }}
                </div>                     
                <div class="table-td" style="width:10%;justify-content: flex-start;max-width: 150px;">
                    {{ countries[shipment.Country] }}
                </div>                                          
                <div class="table-td" style="width:15%;justify-content: flex-start;max-width: 150px;">
                    {{ shipment.service.serviceName }}
                </div>
                <div class="table-td" style="width:30%;justify-content: flex-start;max-width: 150px;">
                    <span class="price-delivery-date" style="text-transform:capitalize;" v-html="$helper.formattedEstimatedPickup(shipment.service)"></span>                  
                </div>                                          
                <div class="table-td" style="width:30%;justify-content: flex-start;max-width: 150px;">
                    <span class="price-delivery-date" v-html="$helper.formattedEstimatedDelivery(shipment.service)"></span> 
                </div>  
                <div class="table-td" style="width:12%;justify-content: flex-start;max-width: 150px;">
                    {{ $helper.getGuaranteed(shipment.service.guaranteed) }}
                </div>                    
                <div class="table-td" style="width:10%;justify-content: flex-start;max-width: 150px;">
                    {{ $helper.getPrice(shipment.service.total_without_vat) }}
                    <button @click="$helper.showInfo(shipment)" class="mass-shipments-toggle"></button>
                </div>
            </div> 
            <div v-show="shipment.show" class="toggle-wrap" :class="`block_${index}_input`" style="display:block;">
                <div class="toggle-content">
                    <div class="form-row">                                                
                        <div class="form-group col-6 col-md-3">
                            <label>* {{ $helper.trans('Company_or_firstname_lastname') }}</label>
                            <input 
                                type="text" 
                                class="form-control to_Company_input"
                                :class="`massShipments_${index}_Company_input`" 
                                :placeholder="'* ' + $helper.trans('Company_or_firstname_lastname')" 
                                v-model="$store.state.massShipments[index].Company"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label>* {{ $helper.trans('Contact_person') }}</label>
                            <input 
                                type="text" 
                                class="form-control to_Contact_input" 
                                :class="`massShipments_${index}_Contact_input`"
                                :placeholder="'* ' + $helper.trans('Contact_person') " 
                                v-model="$store.state.massShipments[index].Contact"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label>* {{ $helper.trans('Phone_number') }}</label>
                            <input 
                                type="text" 
                                class="form-control to_Phone_input"
                                :class="`massShipments_${index}_Phone_input`"
                                :placeholder="'* ' + $helper.trans('Phone_number')" 
                                v-model="$store.state.massShipments[index].Phone"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label>{{ $helper.trans('Contact_email') }}</label>
                            <input 
                                type="text" 
                                class="form-control to_Email_input"
                                :class="`massShipments_${index}_Email_input`" 
                                :placeholder="$helper.trans('Contact_email')" 
                                v-model="$store.state.massShipments[index].Email"
                            >
                        </div>
                    </div>    
                    <div class="form-row">                                                
                        <div class="form-group col-6 col-md-3">
                            <label>* {{ $helper.trans('Address') + ' 1' }}</label>
                            <input 
                                type="text" 
                                class="form-control to_Address1_input" 
                                :class="`massShipments_${index}_Address1_input`"
                                :placeholder="'* ' + $helper.trans('Address') + ' 1'" 
                                v-model="$store.state.massShipments[index].Address1"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label>{{ $helper.trans('Address') + ' 2' }}</label>
                            <input 
                                type="text" 
                                class="form-control to_Address2_input" 
                                :class="`massShipments_${index}_Address2_input`"
                                :placeholder="$helper.trans('Address') + ' 2'" 
                                v-model="$store.state.massShipments[index].Address2"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label>{{ $helper.trans('Address') + ' 3' }}</label>
                            <input 
                                type="text" 
                                class="form-control to_Address3_input"
                                :class="`massShipments_${index}_Address3_input`" 
                                :placeholder="$helper.trans('Address') + ' 3'" 
                                v-model="$store.state.massShipments[index].Address3"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label>* {{ $helper.trans('City') }}</label>
                            <input
                                v-if="$store.state.massShipments[index].Country !== 'us'" 
                                type="text" 
                                @input="checkCountry(index)"
                                class="form-control to_City_input"
                                :class="`massShipments_${index}_City_input`" 
                                :placeholder="'* ' + $helper.trans('City')" 
                                v-model="$store.state.massShipments[index].City"
                            >
                            <select 
                                v-if="$store.state.massShipments[index].Country === 'us'"
                                class="form-control to_City_input" 
                                :class="`massShipments_${index}_City_input`" 
                                @change="checkCountry(index);" 
                                v-model="$store.state.massShipments[index].City"
                            >  
                                <option v-for="(selectedCity, cityIndex) in usCities[index]"
                                    :key="cityIndex"
                                    :value="selectedCity.city"
                                    :selected="cityIndex == $store.state.massShipments[index].City"
                                >{{ selectedCity.city }}</option>
                            </select>
                        </div>
                    </div>    
                    <div class="form-row">                                                
                        <div class="form-group col-6 col-md-3">
                            <label>* {{ $helper.trans('Zip_code') }}</label>
                            <input 
                                type="text" 
                                @input="checkCountry(index);setCityAndState(index)"
                                class="form-control to_postCode_input"
                                :class="`massShipments_${index}_PostCode_input`" 
                                :placeholder="'* '+ $helper.trans('Zip_code')" 
                                v-model="$store.state.massShipments[index].PostCode"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label>{{ $helper.trans('Country') }}</label>
                            <select 
                                class="form-control to_country_mass_input" 
                                :class="`massShipments_${index}_Country_input`" 
                                @change="checkCountry(index)" 
                                v-model="$store.state.massShipments[index].Country"
                            >  
                                <option v-for="(selectedCountry, countryIndex) in countries"
                                    :key="countryIndex"
                                    :value="countryIndex"
                                    :selected="countryIndex == $store.state.massShipments[index].Country"
                                >{{ selectedCountry }}</option>
                            </select>
                        </div>
                        <div class="form-group col-6 col-md-3" v-show="['us', 'ie', 'ca', 'au'].includes($store.state.massShipments[index].Country)">
                            <label>{{ $helper.trans('State') }}</label>
                            <select 
                                class="form-control to_State_input" 
                                :class="`massShipments_${index}_State_input`" 
                                v-model="$store.state.massShipments[index].State"
                            >  
                                <option v-for="(selectedState, stateIndex) in setStates(index)"
                                    :key="stateIndex"
                                    :value="stateIndex"
                                    :selected="setSelected(index, stateIndex, selectedState)"
                                >{{ selectedState }}</option>
                            </select>
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label>{{ $helper.trans('Service') }}</label>
                            <select 
                                class="form-control service_code_input" 
                                :class="`massShipments_${index}_service_input ` + ($store.state.massShipments[index].WrongService ? 'alert-danger-ups' : '')" 
                                v-model="$store.state.massShipments[index].ServiceCode" 
                                @change="changeService(index);"
                            >                                  
                                <option v-for="(service, serviceIndex) in $store.state.$siteSettings['main_services_list']"
                                    :key="serviceIndex"
                                    :value="serviceIndex"
                                    :selected="serviceIndex == $store.state.massShipments[index].ServiceCode"
                                >{{ service }}</option>
                            </select>
                            <span class="ups-danger-text ml-3" v-show="$store.state.massShipments[index].WrongService">
                                {{ $store.state.massShipments[index].ServiceName }} {{ $helper.trans('service_not_found') }}
                            </span>
                        </div>
                    </div>   
                    <div class="form-row">                                                
                        <div class="form-group col-6 col-md-3">
                            <label>{{ $helper.trans('Package') }}</label>
                            <select class="form-control packageType_input" v-model="$store.state.massShipments[index].Package">              
                                <option v-for="(selectedPackage, packageIndex) in getPackageTypes()"
                                    :key="packageIndex"
                                    :value="packageIndex"
                                    :selected="packageIndex == $store.state.massShipments[index].Package"
                                >{{ selectedPackage }}</option>
                            </select>
                        </div>                                                
                        <div class="form-group col-6 col-md-3">
                            <label>{{ $helper.trans('Total_packages') }}</label>
                            <input 
                                type="number" 
                                class="form-control PackagesNum_input"
                                :class="`massShipments_${index}_PackagesNum_input`" 
                                :placeholder="$helper.trans('Total_packages')" 
                                v-model="$store.state.massShipments[index].PackagesNum"
                            >
                        </div>   
                        <div class="form-group col-6 col-md-6">
                            <label>{{ $helper.trans('Description_of_shipment') }}</label>
                            <input 
                                type="text" 
                                class="form-control Description_input"
                                :class="`massShipments_${index}_Description_input`" 
                                :placeholder="$helper.trans('Summarize_description_of_shipment_in_English')" 
                                v-model="$store.state.massShipments[index].Description"
                            >
                        </div>                                                
                    </div>     
                    <div class="form-row">  
                        <div class="form-group col-6 col-md-3">
                            <label>* {{ $helper.trans('Weight_kg') }}</label>
                            <input 
                                type="number" 
                                class="form-control packages_0_weight_input"
                                :class="`massShipments_${index}_Weight_input`" 
                                :placeholder="$helper.trans('Weight_kg')" 
                                v-model="$store.state.massShipments[index].Weight"
                            >
                        </div>                                              
                        <div class="form-group col-6 col-md-3" v-show="$store.state.massShipments[index].Package === '02'">
                            <label>{{ $helper.trans('Length_cm') }}</label>
                            <input 
                                type="number" 
                                class="form-control packages_0_length_input"
                                :class="`massShipments_${index}_Length_input`" 
                                :placeholder="$helper.trans('Length_cm')" 
                                v-model="$store.state.massShipments[index].Length"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3" v-show="$store.state.massShipments[index].Package === '02'">
                            <label>{{ $helper.trans('Width_cm') }}</label>
                            <input 
                                type="number" 
                                class="form-control packages_0_width_input"
                                :class="`massShipments_${index}_Width_input`" 
                                :placeholder="$helper.trans('Width_cm')" 
                                v-model="$store.state.massShipments[index].Width"
                            >
                        </div>
                        <div class="form-group col-6 col-md-3" v-show="$store.state.massShipments[index].Package === '02'">
                            <label>{{ $helper.trans('Height_cm') }}</label>
                            <input 
                                type="number" 
                                class="form-control packages_0_height_input" 
                                :class="`massShipments_${index}_Height_input`"
                                :placeholder="$helper.trans('Height_cm')" 
                                v-model="$store.state.massShipments[index].Height"
                            >
                        </div>            
                        <div class="packet-row packet-column packet-line mt-3 mt-3 mb-0 pb-0" style=" align-items: flex-start;">
                            <label class="strong-label label-margin">{{ $helper.trans('El_messages') }}:</label>
                            <div class="w-100">
                                <table class="table">
                                    <tr>
                                        <td style="width: 55%">{{ $helper.trans('Notification_about') }}:</td>
                                        <td style="width: auto">{{ $helper.trans('About_parcel') }}</td>
                                        <td style="width: auto">{{ $helper.trans('About_exceptions') }}</td>
                                        <td style="width: auto">{{ $helper.trans('About_parcel_delivery') }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="email" class="input-big" v-model="$store.state.massShipments[index].Notifications_to" :placeholder="$helper.trans('Please_type_email')">
                                            <div class="notifications_senderEmail_input"></div>
                                        </td>
                                        <td>
                                            <label :for="'op-23-' + index" class="custom-checkbox-wrap">
                                                <input type="checkbox" :id="'op-23-' + index" v-model="$store.state.massShipments[index].AboutParcel">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>                                       
                                        <td>
                                            <label :for="'op-24-' + index" class="custom-checkbox-wrap">
                                                <input type="checkbox" :id="'op-24-' + index" v-model="$store.state.massShipments[index].AboutExceptions">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <label :for="'op-25-' + index" class="custom-checkbox-wrap">
                                                <input type="checkbox" :id="'op-25-' + index" v-model="$store.state.massShipments[index].AboutParcelDelivery">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>                                   
                                </table>
                            </div>
                        </div>
                        
                        <div class="packet-row packet-column packet-option packet-line mt-3 mb-0 pb-0" style="align-items: flex-start;">
                            <label class="strong-label">{{ $helper.trans('Additional_options') }}: </label>
                            <div class="option-content">                        
                                <div class="checkbox-container">
                                    <label :for="'op-26-' + index" class="custom-checkbox-wrap">
                                        {{ $helper.trans('Required_signatare') }}
                                        <span class="service-tax" v-if="$store.state.massShipments[index].RequireSignature">(€{{ $store.state.$siteSettings['Required_signatare_tax'] }})</span>
                                        <input type="checkbox" v-model="$store.state.massShipments[index].RequireSignature" :id="'op-26-' + index" class="otherDeliveryInformation_requireSignature_input">
                                        <span class="checkmark"></span>
                                    </label>
                                    <i class="fa fa-question-circle info-question-circle">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Required_signatare_info')"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="checkbox-container">
                                    <label :for="'op-27-' + index" class="custom-checkbox-wrap">
                                        {{ $helper.trans('Only_direct_delivery') }}
                                        <span class="service-tax" v-if="$store.state.massShipments[index].DirectDelivery">(€{{ $store.state.$siteSettings['Only_direct_delivery_tax'] }})</span>
                                        <input type="checkbox" v-model="$store.state.massShipments[index].DirectDelivery" :id="'op-27-' + index">
                                        <span class="checkmark"></span>
                                    </label>
                                    <i class="fa fa-question-circle info-question-circle">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Only_direct_delivery_info')"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="checkbox-container">
                                    <label :for="'op-28-' + index" class="custom-checkbox-wrap d-inline">
                                        {{ $helper.trans('Package_reg_ref_num') }}
                                        <input 
                                            type="checkbox" 
                                            v-model="$store.state.massShipments[index].RegistrationNumberChecked" 
                                            :id="'op-28-' + index"
                                            value="1"
                                        >
                                        <span class="checkmark"></span>
                                    </label>
                                    <i class="fa fa-question-circle info-question-circle mr-3">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Register_number_info')"></div>
                                        </div>
                                    </i>
                                    <input 
                                        type="text" 
                                        style="max-width: 200px;" 
                                        v-model="$store.state.massShipments[index].Ref" 
                                        :placeholder="$helper.trans('Register_number')" 
                                        class="input-big mt-2 w-100"
                                    >
                                </div>
                            </div>                                                  
                        </div>
                        <div class="packet-row packet-column packet-line mt-3 mb-0 pb-4 d-inline" v-if="$store.state.massShipments[index].Package != '04'">
                            <label class="strong-label label-margin mb-0 d-inline">{{ $helper.trans('Parcel_insurance_title') }}:</label>
                            <input 
                                type="text" 
                                v-model="$store.state.massShipments[index].Insurance" 
                                class="input-big mt-2"
                                :placeholder="$helper.trans('Parcel_insurance')"
                            >
                        </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center" v-if="$store.state.currentActions.gettingShippingOptions">
                        {{ $helper.trans('Search_for_services') }}
                        <i class="fa fa-cog fa-spin fa-2x ml-2"></i>
                    </div>
                    <div v-show="$store.state.massShipments[index].WrongService">
                        <div class="d-flex justify-content-center align-items-center alert alert-danger mt-5">
                            {{ $store.state.massShipments[index].ServiceName }} {{ $helper.trans('service_not_found') }}
                        </div>
                    </div>
                    <div class="text-center" v-show="!$store.state.selectShippingService">
                            <span style="color: rgba(231, 76, 60, 0.88);">{{ $helper.trans('Select_service') }}</span>
                        </div>
                    <button class="btn btn-warning mt-4" @click="reCount($store.state.massShipments[index], index)">{{ $helper.trans('Recalculate') }}</button>             
                    <button class="btn btn-danger mt-4 float-right" @click="deleteShipment(index)">{{ $helper.trans('Delete_shipment') }}</button>             
                </div>
            </div>
        </div>                                    
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function(){
        return {        
            countries: {}, 
            usStates: {}, 
            ieStates: {}, 
            caStates: {}, 
            auStates: {}, 
            usCities: {}, 
        }
    },
    created: function() {
        let vueThis = this;   

        $.each(vueThis.$store.state.countriesList, function (index, element) { 
            vueThis.countries[element.country_code.toLowerCase()] = element.title;
        });

        $.each(vueThis.$store.state.$siteSettings.State_list, function (index, element) { 
            vueThis.usStates[element.code.toLowerCase()] = element.lt;
        });  
 
        $.each(vueThis.$store.state.$siteSettings.Counties_list, function (index, element) { 
            vueThis.ieStates[element.code.toLowerCase()] = element.lt;
        });

        $.each(vueThis.$store.state.$siteSettings.Province_list, function (index, element) { 
            vueThis.caStates[element.code.toLowerCase()] = element.lt;
        });

        $.each(vueThis.$store.state.$siteSettings.AU_state_list, function (index, element) { 
            vueThis.auStates[element.code.toLowerCase()] = element.lt;
        }); 
    },
    methods: {
        setCitiesFromApi: async function(postCode, index) {
            let vueThis = this;
            let valid = false;
            let url = vueThis.$store.state.$routes['api.get_cities_by_post_code_json'];

            await axios.post(url, {
                postCode: postCode
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(function(response) {
                if (response.data.length > 0) {
                    valid = true;
                }   
                
                let cityValid = false;
                $.each(response.data, function (key, value) { 
                    if (vueThis.$store.state.massShipments[index].City === value.city) {
                        cityValid = true;
                    }
                });
                
                if (!cityValid) {
                    let input = $(`.block_${index}_input`).find('.to_City_input');
                    input.addClass('alert-danger-ups');
                    input.first().parent().find('.ups-danger-text').remove();
                    if (response.data.length > 0) {
                        input.first().parent().append(`<span class="ups-danger-text ml-3">Pasirinkite miestą</span>`);
                    } else {
                        input.first().parent().append(`<span class="ups-danger-text ml-3">Miestas privalomas</span>`);
                    }
                   vueThis.$store.state.massShipments[index].service = [];
                } 

                vueThis.usCities[index] = response.data;
                if (response.data.length === 1) {
                    vueThis.$store.state.massShipments[index].City = response.data[0].city;
                }
                vueThis.$store.state.massShipments[index].State = response.data[0].state.toLowerCase();                  
                 
            }).catch(function(error){               
            });

            return valid;
        },
        setCityAndState: async function(index) {
            let vueThis = this;
            if (vueThis.$store.state.massShipments[index].Country !== 'us') {
                return;
            }

            let valid = await vueThis.setCitiesFromApi(vueThis.$store.state.massShipments[index].PostCode, index);   
            if (valid) {
                vueThis.$forceUpdate();
            }
            
        },
        getPackageTypes() {
            return this.$store.state.$siteSettings['products_map'];
        },
        setStates(index) {
            if (this.$store.state.massShipments[index].Country === 'us') {
                return this.usStates;
            } else if (this.$store.state.massShipments[index].Country === 'ie') {
                return this.ieStates;
            } else if (this.$store.state.massShipments[index].Country === 'ca') {
                return this.caStates;
            } else if (this.$store.state.massShipments[index].Country === 'au') {
                return this.auStates;
            }
        },
        setSelected(index, stateIndex, selectedState) {
            if (this.$store.state.massShipments[index].Country === 'ie' ) {         
                return selectedState.toLowerCase() == this.$store.state.massShipments[index].State;
            } else {
                return stateIndex == this.$store.state.massShipments[index].State;
            }
        },
        checkErrors(errors, blockId) {
            let vueThis = this;  
            $(`.block_${blockId}`).removeClass('alert-danger-ups');
            $.each(errors, function (errorKey, errors) {      
                let inputName = `.${errorKey.replaceAll('.', '_')}_input`;        
                let input = $(`.block_${blockId}_input`).find(inputName);

                if (input.length > 0) {                    
                    $(input).addClass('alert-danger-ups');  
                    $.each(errors, (index, errorText) => {                        
                        $(input).first().parent().append(`<span class="ups-danger-text ml-3">${errorText}</span>`);                              
                    });
                } else {     
                    $.each(errors, (index, errorText) => {
                        showToast(errorText, "#c91a13", 30000);
                    });
                }

                if(vueThis.$store.state.$siteSettings['debug']){
                    console.log(inputName);
                }
            });
        },
        deleteShipment: function (index) {
            if (confirm(this.$helper.trans('Confirm_delete_shipment'))) {
                this.$store.state.massShipments.splice(index, 1);
            }
        },
        reCount: async function(shipment, blockId) {
            let vueThis = this;   
            vueThis.$store.state.currentActions.gettingShippingOptions = true;
            $(`.block_${blockId}_input`).parent().find('.alert-danger-ups').removeClass('alert-danger-ups');
            $(`.block_${blockId}_input`).find('.ups-danger-text').remove();
            
            let url = vueThis.$store.state.$routes['api.get_shipping_options_json'];
            let customDiscounts = [];            
            let packagesDimensions = vueThis.$helper.getDimensionsToMassShipments(shipment, true);

            let data = {
                from: {
                    country: vueThis.$store.state.from.country,
                    postCode: vueThis.$store.state.from.postCode,
                    city: vueThis.$store.state.shipperAddressInformation.city,
                },
                to: {
                    country: shipment.Country,
                    postCode: String(shipment.PostCode),
                    city: shipment.City,
                },
                clientId: null,
                customDiscounts,
                packageType: shipment.Package,
                packages: packagesDimensions
            };  
          
            await axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(function(response) {  
                
                let foundedService = false;
                shipment.status = response.status;                

                if (response.data.rates.length === 0) {
                    shipment.service = {};
                    showToast(vueThis.$helper.trans(response.data.error), "#c91a13", 30000);
                    return;
                }

                $.each(response.data.rates, function (index, element) {
                    if (element.serviceCode === shipment.ServiceCode) {
                        shipment.service = element;
                        foundedService = true;
                        vueThis.$store.state.selectShippingService = true;
                        shipment.WrongService = false;
                        return;
                    }
                });
        
                if (!foundedService) {
                    shipment.WrongService = true;
                    shipment.service = []; 
                    return; 
                }

                shipment.show = false;
                
            }).catch(function(error) {
                if (error.response.status == 422) { 
                    vueThis.$store.state.selectShippingService = false;    
                    shipment.service = [];           
                    vueThis.checkErrors(error.response.data.errors, blockId);
                }
            });      

            vueThis.$store.state.currentActions.gettingShippingOptions = false;
        },
        checkCountry(index) {  
            if(this.$store.state.massShipments[index].Country === 'mt'){
                this.$store.state.massShipments[index].City = this.$helper.getMaltaCity(this.$store.state.massShipments[index].PostCode);
            } 
            if (this.$store.state.massShipments[index].Country === 'ma') {
                this.$store.state.massShipments[index].PostCode = this.$helper.getMoroccoPostCode(this.$store.state.massShipments[index].City);
            }
        }, 
        changeService(index) {
            this.$store.state.massShipments[index].WrongService = false;
            let options = event.target.options
            this.$store.state.massShipments[index].service = [];
            this.$store.state.massShipments[index].ServiceName = options[options.selectedIndex].innerText;
        },
    }, 
    computed: {
        reCheckedMassShipments() {
            let vueThis = this;

            $.each(vueThis.$store.state.massShipments, function (index, element) { 
                vueThis.setCityAndState(index);
            });

            return vueThis.$store.state.massShipments;
        }
    }
}
</script>
